import { render, staticRenderFns } from "./ConsumRecords.vue?vue&type=template&id=50217314"
import script from "./ConsumRecords.vue?vue&type=script&lang=js"
export * from "./ConsumRecords.vue?vue&type=script&lang=js"
import style0 from "./ConsumRecords.vue?vue&type=style&index=0&id=50217314&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports